import { gql } from "@apollo/client";

// Query to poll import job status after file upload.
// Pass the uploadId returned by initMultipartUpload as eventId.
export const GET_CODE_GROUP_IMPORT = gql`
  query GetCodeGroupImport($eventId: ID!) {
    getCodeGroupImport(eventId: $eventId) {
      jobId
      codeGroupId
      status
      chunksTotal
      chunksDone
      originalFilename
      codesInserted
      duplicatesSkipped
      errorMessage
      createdBy
      createdAt
      updatedAt
    }
  }
`;

export const getCodeGroups = gql`
  query ListCodeGroups($filter: CodeGroupFilter) {
    listCodeGroups(filter: $filter) {
      codeGroupId
      codesGeneratedCount
      administrationStatus
      codesUsedCount
      lifecycleStatus
      category
      creationType
      basicSetup {
        codeActiveStartDate
        codeActiveEndDate
        codeGroupName
      }
      producerPackaging {
        codesPrintedCount
      }
    }
  }
`;

export const getCodeGroupByIds = gql`
  query loadCodeGroupsByIds($ids: [ID!]!) {
    loadCodeGroupsByIds(ids: $ids) {
      exportUrl
      codeGroupId
      codesGeneratedCount
      administrationStatus
      lifecycleStatus
      category
      creationType
      basicSetup {
        codeGroupName
        codeActiveStartDate
        codeActiveEndDate
      }
      producerPackaging {
        brand
        producerCompany
        codesPrintedCount
        productVolume
        packageType
        productCapColor
      }
      codeSpecifications {
        codeLength
        usePrefix
        prefixVal
        useSuffix
        suffixVal
        caseSensitive
        excludeCharacters
        excludeCharacterValues
      }
      compositeStatus
    }
  }
`;
